import { Spinner } from './style';

export default Spinner;